// Data for different collection and product
const dataSet = [ 
  {
    type: "pfannen",
    single: "<strong>Gute Wahl!</strong> Hier ist Ihre Hoffmann Pfanne",
    multiple: "<strong>Gute Wahl!</strong> Hier sind Ihre Hoffmann Pfannen",
  },
  {
    type: "kochtöpfe",
    single: "<strong>Gute Wahl!</strong> Hier ist Ihr Hoffmann Kochtopf",
    multiple: "<strong>Gute Wahl!</strong> Hier sind Ihre Hoffmann Kochtöpfe",
  },
  {
    type: "bräter",
    single: "<strong>Gute Wahl!</strong> Hier ist Ihr Hoffmann Bräter",
    multiple: "<strong>Gute Wahl!</strong> Hier sind Ihre Hoffmann Bräter",
  },
  {
    type: "woks",
    single: "<strong>Gute Wahl!</strong> Hier ist Ihr Hoffmann Wok",
    multiple: "<strong>Gute Wahl!</strong> Hier sind Ihre Hoffmann Woks",
  },
  {
    type: "grillpfannen",
    single: "<strong>Gute Wahl!</strong> Hier ist Ihre Hoffmann Grillpfanne",
    multiple: "<strong>Gute Wahl!</strong> Hier sind Ihre Hoffmann Grillpfannen",
  },
  {
    type: "grillplatten",
    single: "<strong>Gute Wahl!</strong> Hier ist Ihre Hoffmann Grillplatte",
    multiple: "<strong>Gute Wahl!</strong> Hier sind Ihre Hoffmann Grillplatten",
  },
  {
    type: "backplatten",
    single: "<strong>Gute Wahl!</strong> Hier ist Ihre Hoffmann Backplatte",
    multiple: "<strong>Gute Wahl!</strong> Hier sind Ihre Hoffmann Backplatten",
  },
  {
    type: "mixed",
    single: "<strong>Gute Wahl!</strong> Hier ist Ihr Hoffmann Produkt",
    multiple: "<strong>Gute Wahl!</strong> Hier sind Ihre Hoffmann Produkte",
  },
];

// Helper functions
const getCartSize = () => {
  const cartItems = document.querySelectorAll("#shopify-section-mini-cart .CartItemWrapper .CartItem");
  return cartItems.length;
};

const getIndvidualQuantity = (cartItem) => {
  const quantity = cartItem.dataset.item_qty;
  return quantity;
};

const getCartMessage = (cartSize) => {
  let cartMessage = "";

  /**
   * For multiple items in the cart.
   */
  if (cartSize > 1) {
    const uniqueTypes = new Set();
    document.querySelectorAll("#shopify-section-mini-cart .CartItemWrapper .CartItem__Info").forEach((item) => {
      let collections = (item.dataset.collections || "")
        .toLowerCase()
        .split(",")
        .map((col) => col.trim());
      
      // const matchedData = dataSet.find((data) => collections.includes(data.type));
      const matchedTypes = dataSet.filter((data) => collections.includes(data.type) && data.type !== "mixed");
      console.log("matchedTypes", matchedTypes);
      const matchedData = matchedTypes.length > 0 
        ? matchedTypes.reduce((prev, current) => (current.type.length > prev.type.length) ? current : prev)
        : null;
      console.log("matchedData", matchedData);

      if (matchedData) {
        uniqueTypes.add(matchedData.type);
        console.log("uniqueTypes", uniqueTypes);
      } else {
        uniqueTypes.add("random");
      }
    });

    if (uniqueTypes.size > 1) {
      cartMessage = dataSet.find((data) => data.type === "mixed").multiple;
      return cartMessage;
    }
  }

  /**
   * For single item in the cart.
   * Check the signle item quantity and if the item is a mixed product.
   */
  document.querySelectorAll("#shopify-section-mini-cart .CartItemWrapper .CartItem__Info").forEach((item) => {
    let collections = (item.dataset.collections || "")
      .toLowerCase()
      .split(",")
      .map((col) => col.trim());
    const quantity = getIndvidualQuantity(item);
    console.log(
      "collections", collections,
    )

    // const matchedData = dataSet.find((data) => collections.includes(data.type));
    const matchedTypes = dataSet.filter((data) => collections.includes(data.type) && data.type !== "mixed");
    console.log("matchedTypes", matchedTypes);
    const matchedData = matchedTypes.length > 0 // getting the longer matching type. As, in some products, pfannen and grillpfannen are both present as collection. So, we need to get the longer matching type for accuracy.
      ? matchedTypes.reduce((prev, current) => (current.type.length > prev.type.length) ? current : prev)
      : null;
    console.log("matchedData", matchedData);
    if (matchedData && cartSize == 1) {
      cartMessage = quantity > 1 ? matchedData.multiple : matchedData.single;
    } else if (matchedData && cartSize > 1) {
      cartMessage = matchedData.multiple;
    } else if (!matchedData && cartSize == 1) {
      cartMessage = quantity > 1 ? dataSet.find((data) => data.type === "mixed").multiple : dataSet.find((data) => data.type === "mixed").single;
    } else if (!matchedData && cartSize > 1) {
      cartMessage = dataSet.find((data) => data.type === "mixed").multiple;
    }
  });

  return cartMessage;
};


const updatePersonalizationMessage = () => {
  const cartSize = getCartSize();
  console.log("cartSize", cartSize);
  const messageWrapper = document.querySelector('.Drawer .personalize_message');
  if(cartSize > 0) {
    const cartMessage = getCartMessage(cartSize);
    if(messageWrapper) {
      messageWrapper.classList.remove('message_hidden');
      const messageElement = document.querySelector('.Drawer .personalize_message .content');
      messageElement.innerHTML = cartMessage;
    }
  } else {
    if(messageWrapper) {
      messageWrapper.classList.add('message_hidden');
    }
  }
};

// Initialize message on page load
updatePersonalizationMessage();

document.addEventListener('cart:personalization:update', updatePersonalizationMessage);
